import React from "react";

const NavbarInnerCircle = (props) => {
  const { first, navbarNumber, active, navbarEducator, hover } = props;
  return (
    <div className="navbar-inner">
      <div
        className="navbar-inner-circle"
        style={{
          border: first ? "white solid 1px" : "black solid 1px",
          backgroundColor: navbarEducator
            ? hover
              ? "white"
              : "red"
            : first
            ? "white"
            : navbarNumber === active
            ? "black"
            : null,
        }}
      ></div>
    </div>
  );
};

export default NavbarInnerCircle;
